import React, { useEffect } from "react";
import styles from "./style.module.css";
import sectionStyles from "../sectionStyles.module.css";
import { TEXTS } from "../../static/texts";
import Carousel from "../../components/carousel";
import { IMAGES } from "../../static/assets/images";

const piezas = [
  {
    header: "Concrebloq",
    subHeader: TEXTS.PIEZAS_CONCREBLOQ_SUBHEADER,
    description: TEXTS.PIEZAS_CONCREBLOQ_DESCRIPTION,
    slides: [IMAGES.SLIDE_CONCREBLOQ],
  },
  {
    header: "Concret Camellón",
    subHeader: TEXTS.PIEZAS_CONCRET_CAMELLON_SUBHEADER,
    description: TEXTS.PIEZAS_CONCRET_CAMELLON_DESCRIPTION,
    slides: [
      IMAGES.SLIDE_CAMELLON_1,
      IMAGES.SLIDE_CAMELLON_2,
      IMAGES.SLIDE_CAMELLON_3,
      IMAGES.SLIDE_CAMELLON_4,
      IMAGES.SLIDE_CAMELLON_5,
      IMAGES.SLIDE_CAMELLON_6,
      IMAGES.SLIDE_CAMELLON_7,
    ],
  },
  {
    header: "Escaleras prefabricadas",
    subHeader: null,
    description: TEXTS.PIEZAS_ESCALERAS_DESCRIPTION,
    slides: [
      IMAGES.SLIDE_ESCALERAS_1,
      IMAGES.SLIDE_ESCALERAS_2,
      IMAGES.SLIDE_ESCALERAS_3,
      IMAGES.SLIDE_ESCALERAS_5,
      IMAGES.SLIDE_ESCALERAS_6,
      IMAGES.SLIDE_ESCALERAS_7,
      IMAGES.SLIDE_ESCALERAS_8,
      IMAGES.SLIDE_ESCALERAS_9,
    ],
  },
  {
    header: "Concrecam",
    subHeader: TEXTS.PIEZAS_CONCRECAM_SUBHEADER,
    description: TEXTS.PIEZAS_CONCRECAM_DESCRIPTION,
    slides: [
      IMAGES.SLIDE_CONCRECAM_1,
      IMAGES.SLIDE_CONCRECAM_2,
      IMAGES.SLIDE_CONCRECAM_3,
    ],
  },
];

export const Piezas = ({ pageTop }) => {
  useEffect(() => {
    pageTop.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [pageTop]);
  return (
    <>
      <div className={styles.bannerContainer}>
        <h1 className={sectionStyles.titleText}>
          {TEXTS.SERVICES_PIEZAS_TITLE}
        </h1>
      </div>
      <div className={sectionStyles.redContainer}>
        <p className={sectionStyles.flavorText}>
          {TEXTS.SERVICES_PIEZAS_FLAVOR}
        </p>
      </div>
      <div className={sectionStyles.blackContainer}>
        {piezas.map((pieza, index) => (
          <>
            <Carousel key={index} carouselData={pieza} />
            {index < piezas.length - 1 && (
              <div className={sectionStyles.separator} />
            )}
          </>
        ))}
      </div>
    </>
  );
};
